import React, { useEffect, useRef, useState } from "react"
import api from "../../seller-apis/api";
import { fetchOpportunityData } from "../../seller-apis/apidataField";
import { Actions } from "../../Actions/Actions";
import { useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import OrderSKUSearch from "../common/ProductSearch/OrderSKUSearch";
import servicesApi from "../../seller-apis/servicesApi";
import PaginationNew from "../common/Pagination";
import Popup from "../common/Popup";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import UpdtProPopup2 from "../common/UpdtProPopup2";
//SL-660 Grab Order Success Popup
import SuccessPopup from "../common/SuccessPopup";
import MainLoader from "../common/Loader/PageLoader";

var globalFilterData = {
    pageNo: 1,
    size: 12,
    filters: {
        "status": "pending",
        "orderType": 'grab_order'
    },
    sortFilter: { "createdAt": -1 },
};

var searchParam = {
    // "status": "pending",
    //"orderType" : 'grab_order'
};
var productsDetails = {}
function GrabOrders() {
    const alert = useAlert();
    const dispatch = useDispatch();
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [ennewloader, setennewloader] = useState("none");
    const [totalRcord, setTotalReord] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchPro, setsearchPro] = useState();
    const [searchType, setSearchType] = useState("Product Name");
    const [detailPPrice, setdetailPPrice] = useState("");
    const [productDetail, setproductDetail] = useState([
        {
            "description": undefined,
            "sdescription": undefined,
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
        }
    ]);
    const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
    const [updtProVisibility, setupdtProVisibility] = useState(false);
    const [cbimg, setcbimg] = useState();
    const [selectedProductPopup, setselectedProductPopup] = useState();
    const [clickedUpdateNo, setclickedUpdateNo] = useState();
    const [updtPopuprel, setupdtPopuprel] = useState([]);
    const [otherSellerPrice, setotherSellerPrice] = useState();
    const [opportunityId, setOpportunityId] = useState(null);
    const [selectPopupBrandName, setSelectPopupBrandName] = useState()
    const [expectedPriceFrom, setExpectedPriceFrom] = useState()
    const [expectedPriceTo, setExpectedPriceTo] = useState()
    var currentDate = new Date();
    const outerdivRef = useRef(null);
    const loaderDivRef = useRef(null);
    //SL-660 Success Popup
    const [isSuccessPopupVisible, setSuccessPopupVisible] = useState(false);
    //SL-675
    const [totalRcordId, setTotalReordId] = useState([]);

    //Handle Success Popup Close
    const handleSuccessPopupClose = () => {
        setSuccessPopupVisible(false);
    };
    const [currSelProduct, setCurrSelProduct] = useState(null);

    function applyLoader() {
        if (loaderDivRef.current && outerdivRef.current) {
            loaderDivRef.current.classList.add("loader-bt");
            setennewloader("flex");
            outerdivRef.current.classList.add("div-bk");
        }
    }

    function removeLoader() {
        if (loaderDivRef.current && outerdivRef.current) {
            setennewloader("none");
            loaderDivRef.current.classList.remove("loader-bt");
            outerdivRef.current.classList.remove("div-bk");
        }
    }

    useEffect(() => {
        if (window.location.hash === '#popupDetail') {
            history.replace(window.location.pathname); // Replace the current URL
            setpopupVisibilityDetail()
        }
        globalFilterData = {
            pageNo: 1,
            size: 12,
            filters: {
                "status": "pending",
                "orderType": 'grab_order'
            },
            sortFilter: { "createdAt": -1 },
        };
        //SL-675
        globalFilterData["productId"] = totalRcordId.length == 0 ? true : false;
        applyLoader();
        api.Opportunity.fetchOpportunity(fetchOpportunityData(globalFilterData))
            .then((review) => {
                setTotalReord(review.totalRecords);
                //Actions.GrabOrderCountAction(dispatch, review.totalRecords);
                let data = review.data;
                setTickets(data);
                if (totalRcordId.length == 0) {//SL-675
                    setTotalReordId(review?.productId);
                    globalFilterData["productId"] = false;
                }
                removeLoader();
            });
    }, []);
    const getOpportunity = (filterData) => {
        applyLoader();
        api.Opportunity.fetchOpportunity(fetchOpportunityData(filterData)).then((review) => {
            setTotalReord(review.totalRecords);
            Actions.GrabOrderCountAction(dispatch, review.totalRecords);
            Actions.OrderCountAction(dispatch, { grabOrders: review.totalRecords });
            let data = review.data;
            setTickets(data);
            removeLoader();
        });
    };

    // Check response of product added
    function callbackResponse(msg) {

        if (msg === "product added" || msg === "product updated") {

            setupdtProVisibility(false);
            setSuccessPopupVisible(true);//SL-660 Success Popup
            //alert.success("Product Added Successfully");
            if (opportunityId !== null) {

                api.Opportunity.deleteOpportunity(opportunityId).then(res => {

                }).catch((err) => console.log(err));
            }
            getOpportunity(globalFilterData);
        }
        else {
            setupdtProVisibility(false)
            alert.error("Product not added")
        }
    }

    function checkpopupvisibility(e) {
        if (e === false) {
            setupdtProVisibility(false)
            setCurrSelProduct(null);
        }
        else {
            setupdtProVisibility(true)
        }
    }

    //set add this product popup show issue
    function handleAddProduct(img, ticket) {
        console.log("ticket", ticket)
        setCurrSelProduct(ticket)
        //SL-660 Grab Order Attribute Case
        let mAttributeValue = [];
        if (ticket?.order?.products && ticket.order.products.length > 0) {
            const mProObject = ticket.order.products[0];
            if (Object.keys(mProObject).length > 0 && mProObject?.selSubPrd
                && Object.keys(mProObject.selSubPrd).length > 0)
                mAttributeValue = mProObject.selSubPrd.value;
        }

        let pkgs = [];
        if (mAttributeValue.length > 0) {
            ticket?.pkgs?.forEach(element => {
                //SL-660 For Attribute Package
                if (element?.pkg && element.pkg.length > 1) {
                    element.pkg.forEach(mPkgObj => {
                        const areIdentical = JSON.stringify(mAttributeValue) === JSON.stringify(mPkgObj?.value);
                        if (areIdentical && mPkgObj?.pkgs) {
                            mPkgObj.pkgs.forEach(mAttrPkg => {
                                pkgs.push(mAttrPkg);
                            });
                        }
                    });
                }

            });
        }
        else if (ticket?.pkgs && ticket.pkgs.length > 0)
            pkgs = ticket?.pkgs[0]?.pkg;

        let details = {
            "SKU": ticket?.productId?.SKU,
            "taxClass": ticket?.productId?.taxClass,
            "pkgs": pkgs,
            "categories": ticket?.categories,
            "shortDescription": ticket?.productId?.shortDescription,
            "description": ticket?.productId?.description,
            "attributeList": ticket?.attributeList,
            "combination": ticket?.combination,
            "vendor": ticket?.vendors?.[0],
            "product": ticket.productId,
            "_id": ticket?.productId?._id,
            "orderId": ticket?.order?.orderId

        }
        productsDetails = {
            "_id": ticket.productId._id,
            "name": ticket.productId.productName,
            "images": ticket.productId.images,
            "SKU": ticket.SKU,
            "taxClass": ticket.taxClass,
            "pkgs": pkgs,
            "categories": ticket.categories,
            "orderId": ticket?.order?.orderId
        };
        //SL-660 Grab Order Attribute Case
        if (ticket?.order?.products && ticket.order.products.length > 0) {
            const mProObject = ticket.order.products[0];
            if (Object.keys(mProObject).length > 0 && mProObject?.selSubPrd
                && Object.keys(mProObject.selSubPrd).length > 0)
                productsDetails['url'] = mProObject?.selSubPrd?.url;
            details['url'] = mProObject?.selSubPrd?.url;

        }
        setupdtPopuprel(details);

        const ExpectedpriceFrom = Math.ceil(ticket.expTransferPriceFrom || 0);
        const ExpectedpriceTo = Math.ceil(ticket.expTransferPriceTo || 0);
        setcbimg(img);
        setselectedProductPopup(ticket.productName);
        setclickedUpdateNo(ticket.productId);
        setOpportunityId(ticket._id);
        setupdtProVisibility(true);
        setotherSellerPrice(ticket.onClick);
        setSelectPopupBrandName(ticket.brandName)
        setExpectedPriceFrom(ExpectedpriceFrom)
        setExpectedPriceTo(ExpectedpriceTo)
    }

    // Popup showing 
    function detail(data, price, ticket = null) {

        setdetailPPrice(price)

        if (data && data[0] === undefined) {
            setproductDetail(
                [
                    {
                        "description": "No details available",
                        "sdescription": "No short description",
                        "name": undefined,
                        "price": undefined,
                        "SKU": undefined,
                        "popupVisibility": undefined,
                        "images": []
                    }
                ]
            )
        }
        else {
            // Determine the product source (ticket or currSelProduct)
            const mProduct = ticket || currSelProduct;

            //SL-660 Grab Order Attribute Case
            let mAttributeValue = [];
            if (mProduct?.order?.products && mProduct.order.products.length > 0) {
                const mProObject = mProduct.order.products[0];
                if (Object.keys(mProObject).length > 0 && mProObject?.selSubPrd
                    && Object.keys(mProObject.selSubPrd).length > 0)
                    mAttributeValue = mProObject.selSubPrd.value;
            }
            let pkgs = [];
            if (mAttributeValue.length > 0) {
                mProduct?.pkgs?.forEach(element => {
                    //SL-660 For Attribute Package
                    if (element?.pkg && element.pkg.length > 1) {
                        element.pkg.forEach(mPkgObj => {
                            const areIdentical = JSON.stringify(mAttributeValue) === JSON.stringify(mPkgObj?.value);
                            if (areIdentical && mPkgObj?.pkgs) {
                                mPkgObj.pkgs.forEach(mAttrPkg => {
                                    pkgs.push(mAttrPkg);
                                });
                            }
                        });
                    }
                });
            }
            else if (mProduct?.pkgs && mProduct.pkgs.length > 0)
                pkgs = mProduct?.pkgs[0]?.pkg;

            data[0].pkgs = pkgs;
            setproductDetail(data)
        }
    }

    //Popup related functions
    function setpopupVisibilityDetail(e) {
        if (e) {
            setisDetailPopupVis("block")
        }
        else {
            setisDetailPopupVis("none")
            setCurrSelProduct(null)
        }
    }

    //refresh productpopup
    const params = window.location.hash

    useEffect(() => {
        // setpopupVisibilityDetail("");
        if (params) {
            const url = localStorage.getItem("productUrl")
            const price = localStorage.getItem("productPrice")
            let data =
            {
                "filter": { "urlKey": url }
            }
            servicesApi.getProductDetail(data).then((res) => {
                detail([res.data], price)

                setpopupVisibilityDetail("2");
            }).catch(err => console.log(err))
        }

    }, [params])

    // For product
    const detailnew = (ticket, url, price) => {
        //set localStorage
        localStorage.setItem("productUrl", url)
        localStorage.setItem("productPrice", price)
        setCurrSelProduct(ticket);

        let data =
        {
            "filter": { "urlKey": url }
        }
        servicesApi.getProductDetail(data).then((res) => {
            detail([res.data], price, ticket)

            setpopupVisibilityDetail("2");
        }).catch(err => console.log(err))

    }

    const filterSearch = (data) => {
        //setsearchPro(data.data);
        //setSearchType(data.type)

        //productId-objectId filed set
        globalFilterData['filters'] = { ...globalFilterData.filters, "productId-objectId": data.data }
        if (globalFilterData?.searchIds)
            delete globalFilterData['searchIds'];
        globalFilterData.pageNo = 1;
        getOpportunity(globalFilterData);
        //SL-660
        if (globalFilterData?.filters && globalFilterData['filters']['productId-objectId'])
            delete globalFilterData['filters']['productId-objectId'];
    }

    function paginate(data) {

        setCurrentPage(data.number);
        let filter = globalFilterData;
        filter['pageNo'] = data.number;
        getOpportunity(filter);
    }

    const ApiCalling = () => {

        if (globalFilterData?.searchIds)
            delete globalFilterData['searchIds'];
        globalFilterData.pageNo = currentPage;
        getOpportunity(globalFilterData)
    }

    const maskOrderId = (orderId) => {
        if (!orderId) return '';
        const mainPart = orderId.split('/')[0];
        return mainPart.slice(0, -2) + '**';

    };

    /**
* Search By Keyword On Enter
*/
    const searchByKeyword = (value, type, productIds) => {

        if (productIds.length > 0) {
            globalFilterData['searchIds'] = productIds
            //Search Issue on Other than 1st Page SL-698 and SL-675
            globalFilterData.pageNo = 1;
            setCurrentPage(1);
            getOpportunity(globalFilterData);


        }
        else {
            setTickets([]);
            setTotalReord(0);

        }
    }

    return (
        <div>
            <div className="table-responsive">
                <table className="ord_table new-table-design" style={{ "width": "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ "width": "10%" }}>
                                Order ID
                            </th>
                            <th className='thead_title' style={{ "width": "10%" }}>Product image</th>
                            <th style={{ width: '30%' }}>
                                Product Details
                                <div className='topprodsearch flex-column'>
                                    <OrderSKUSearch
                                        filterSearch={filterSearch}
                                        searchNewEnq={setsearchPro}
                                        searchParam={searchParam}
                                        from="orders"
                                        flag="Order" //flag set
                                        apiCall={ApiCalling}
                                        //apiurl="OtherSellerProducts"
                                        apiurl="searchSellerProductsFilter"
                                        data="filedData"
                                        totalRcordId={totalRcordId}
                                        searchByKeyword={searchByKeyword}
                                    />
                                </div>
                            </th>
                            <th style={{ "width": "10%" }}>
                                Expected Transfer Price
                            </th>
                            <th style={{ "width": "10%" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody id="orDeskContain" ref={outerdivRef}>
                        {tickets.length > 0 && tickets.map((ticket, index) => {

                            let baseImg;
                            ticket.images.map((item) => {
                                if (item.baseImage === true) {
                                    if (item.image.startsWith("products")) {
                                        baseImg = item.image;
                                    }
                                    else {
                                        let img = item.image.substr("41")
                                        baseImg = img;
                                    }
                                }
                            })
                            let pkgs = [];
                            ticket?.pkgs?.forEach(element => {
                                pkgs.push(element?.pkg[0])
                            });

                            const ExpectedpriceFrom = Math.ceil(ticket.expTransferPriceFrom || 0);
                            const ExpectedpriceTo = Math.ceil(ticket.expTransferPriceTo || 0);
                            const orderId = ticket?.order?.orderId;
                            const maskedId = maskOrderId(orderId);

                            return (
                                <tr>
                                    <td>
                                        <div className='border-x p-4'>
                                            {maskedId}
                                        </div>
                                    </td>
                                    <td className="td-img-cntn">
                                        <div className='border-x'>
                                            <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                                        </div>
                                    </td>
                                    <td className='fs-13 order_table_pname_cntn'>
                                        <div className="d-flex">
                                            <div className='inline-initial border-x'>
                                                <a href='#popupDetail' onClick={() => detailnew(ticket, ticket.urlKey,
                                                    Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0
                                                        ? ticket?.order?.products[0]?.selSubPrd?.price : ticket?.productId?.price)} className='prod-name'>{ticket.productName}</a>
                                                <div className='order_table_sku'>SKU:- {ticket.SKU}</div>
                                                <div className='order_table_sku'>Quantity:- {ticket?.order?.products[0]?.quantity || 0}</div>
                                                {Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0 &&
                                                    <div className="product-package-details">
                                                        {Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0 && ticket?.productId?.combination.map((item, index) => {
                                                            return (
                                                                <>
                                                                    {index == 0 &&
                                                                        <div key={index} className="type" value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[0]} :</div>
                                                                    }
                                                                    {index > 0 && item.url == ticket?.order?.products[0]?.selSubPrd?.url &&
                                                                        <div className={`comb ${item.url == ticket?.order?.products[0]?.selSubPrd?.url && "active"}`} key={index} value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[0]}</div>
                                                                    }</>
                                                            )
                                                        })}
                                                    </div>}
                                                {Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0 &&
                                                    <div className="product-package-details">
                                                        {Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0 && ticket?.productId?.combination.map((item, index) => {
                                                            return (
                                                                <>
                                                                    {index == 0 &&
                                                                        <div key={index} className="type" value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[1] ? `${item.value[1]} : ` : ""}</div>
                                                                    }
                                                                    {index > 0 && item.url == ticket?.order?.products[0]?.selSubPrd?.url &&
                                                                        <div className={`comb ${item.url == ticket?.order?.products[0]?.selSubPrd?.url && "active"}`} key={index} value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[1]}</div>
                                                                    }</>
                                                            )
                                                        })}
                                                    </div>}
                                                <a href='#popupDetail' onClick={() => detailnew(ticket, ticket.urlKey,
                                                    Array.isArray(ticket?.productId?.combination) && ticket?.productId?.combination.length > 0
                                                        ? ticket?.order?.products[0]?.selSubPrd?.price : ticket?.productId?.price)} className='detail-but'>
                                                    <button style={{ marginBottom: '10px' }} className='px-1 order_table_btn_details'>View Details</button>
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                    {ExpectedpriceTo && ExpectedpriceFrom ?
                                        <td>
                                            <div className='border-x'>
                                                <div className="d-flex align-items-center">
                                                    <i class="fa fa-inr" aria-hidden="true"></i> {ExpectedpriceFrom}&nbsp;
                                                    -
                                                    &nbsp;<i class="fa fa-inr" aria-hidden="true"></i> {ExpectedpriceTo}
                                                </div>
                                            </div>
                                        </td> : <td>
                                            <div className='border-x'>-</div>
                                        </td>
                                    }
                                    <td>
                                        <div className='border-x'>
                                            <a href="#" className='fw-bold'
                                                style={{
                                                    color: '#168A86',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline',
                                                }}
                                                onClick={() => handleAddProduct(baseImg, ticket)}>
                                                Click here
                                            </a>
                                            to Grab this Order
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <PaginationNew
                number={totalRcord}
                paginate={paginate}
                activ={currentPage}
                comp={"support"}
            />

            <div class="d-flex justify-content-center" id="enNewLoader" ref={loaderDivRef}>
                <div
                    style={{ display: ennewloader }}
                >
                    <MainLoader/>
                </div>
            </div>

            <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                <Popup
                    from="newOrder"
                    description={productDetail[0].description}
                    sdescription={productDetail[0].shortDescription}
                    descriptionNew={productDetail[0].descriptionNew}
                    specificationNew={productDetail[0].specificationNew}
                    name={productDetail[0].productName}
                    price={detailPPrice}
                    SKU={productDetail[0].SKU}
                    pkgs={productDetail[0]?.pkgs}
                    manufacturerName={productDetail[0]?.manufacturerName}
                    popupVisibility={setpopupVisibilityDetail}
                    images={productDetail[0].images}
                    videos={productDetail[0].videos}
                    fixedImage={true}
                    hideTransferPrice={true}
                />
            </div>

            {updtProVisibility === true ?
                <UpdtProPopup2
                    lead={clickedUpdateNo?._id}
                    productName={selectedProductPopup}
                    Popupvisible="block"
                    img={cbimg}
                    detail={updtPopuprel}
                    lowestPrice={otherSellerPrice}
                    pkgs={productDetail[0]?.pkgs}
                    manufacturerName={productDetail[0]?.manufacturerName}
                    Popupvisibilityfun={checkpopupvisibility}
                    from="chooseProduct"
                    callbackResFun={callbackResponse}
                    brandName={selectPopupBrandName}
                    expectedPriceTo={expectedPriceTo}
                    expectedPriceFrom={expectedPriceFrom}
                    flag="Grab Order"
                /> : <></>
            }
            {/*SL-660 Grab Order SUccess Popup */}
            {isSuccessPopupVisible === true ?
                <SuccessPopup product={productsDetails} onClose={handleSuccessPopupClose} /> : <></>
            }
        </div>

    )
}

export default GrabOrders;